<template>
  <label
    class="Checkbox justify-content-start px-1"
    :class="{'SubOpts-itm--selected' : isChecked}"
    @click="updateInput"
  >
    <input
      class="Checkbox-input"
      type="radio"
      :checked="isChecked"
      :value="value"
      :disabled="disabled"
      :name="name"
    >
    <i
      class="Checkbox-customIcon d-none"
      aria-hidden="true"
    ></i>
    <i
      aria-hidden="true"
      class="Checkbox-customIcon Radiobutton"
      :class="{'Checkbox-customIcon--selected Radiobutton--selected' : isChecked}"
    ></i>
    <span
      class="Checkbox-lit ml-2 my-auto"
      :class="labelClass"
    >{{$t(label)}}</span>
    <slot name="extra-info"></slot>
  </label>
</template>

<script>
export default {
  name: 'InputRadio',
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    value: {
      type: [String, Number, Boolean, Object]

    },
    itemValue: {
      type: [String, Number, Boolean, Object],
      default: false

    },
    labelClass: {
      type: String,
      default: 'Label Label--form'
    },
    extraInfo: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      status: false
    }
  },
  computed: {
    isChecked () {
      return this.value === this.itemValue
    }
  },
  methods: {
    updateInput () {
      if (this.disabled) return
      this.$emit('click', this.value)
    }

  }

}
</script>

<style scoped>
.Radiobutton {
  border-radius: 15px;
  height: 14px;
  width: 14px;
}
.Radiobutton--selected:after {
  border-radius: 15px;
  width: 8px;
  height: 8px;
  left: 2px;
  top: 2px;
}
label {
  margin-bottom: 0px;
}

.input-radio--label {
  font-size: 0.8rem;
}
.disabled {
  background-color: var(--action-disabled);
}

.Fuell-Text {
  font-size: 14px;
}
</style>
